module.exports = __webpack_public_path__ + "static/media/maybury_park.48c91a33.pdf";